import React from 'react';
import { Stack } from '@mui/material';
import ThoughtSpotIntegration from './ThoughtspotIntegration';

const DepartmentDownloads: React.FC = () => {
  return (
    <Stack
      pt={2}
      bgcolor={'#F6F8FA'}
      sx={{ width: '100%', height: '100%', overflowY: 'hidden' }}
    >
      <ThoughtSpotIntegration who="dor" />
    </Stack>
  );
};

export default DepartmentDownloads;
